module.exports = __webpack_public_path__ + "static/media/WiCS Coffee Chats.ba1fb98c.png";